import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { RedocStandalone } from 'redoc';
import Select from 'react-select'
import "core-js/stable";
import "regenerator-runtime/runtime";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {shouldShowNotification, showToast} from './toastHelper';
import {getCookie, cookieName} from "./cookieHelper";
import { description } from './description';

const options = [
    {value: "API_3.1.yaml", label: 'Version 3.1'},
    {value: "API_2.1.yaml", label: 'Version 2.1'},
    {value: "API_2.0.yaml", label: 'Version 2.0'},
];

const lastSeenNotificationIds = getCookie(cookieName);

const colors = {
    blackish: '#333333',
    greyish: '#fafafa',
    darkGreyish: '#bdc1c3'
}

const customStyles = {
    dropdownIndicator: provided => ({
        ...provided,
        color: colors.blackish,
        paddingRight: '16px',
    }),
    indicatorSeparator: provided => ({
        ...provided,
        width: '0',
    }),
    container: provided => ({
        ...provided,
        margin: '20px',
    }),
    menu: provided=> ({
        ...provided,
        maxWidth: '220px',
        borderRadius: '0',
        backgroundColor: colors.greyish,
    }),
    control: provided => ({
        ...provided,
        borderRadius: '2px',
        borderColor: colors.darkGreyish,
        backgroundColor: colors.greyish,
        height: '46px',
    }),
    placeholder: provided => ({
        ...provided,
        color: colors.blackish,
        paddingLeft: '12px',
        paddingTop: '11px',
        paddingBottom: '11px',
        fontWeight: 'normal',
    })
};

var value = "";
var version = options[0].label;

class Page extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specUrl: options[0].value
        };
        if(window.location.href.indexOf("docs.pingdom.com") != -1) {
            var script = document.createElement("script");  // create a script DOM node
            script.src = "//rum-static.pingdom.net/pa-5da78ad23a70310008000612.js";  // set its src to the provided URL
            script.async = true;
            document.head.appendChild(script);
        }
    }

    selectChange = selectedOption => {
        this.setState({
            specUrl: selectedOption.value
        });
        value = selectedOption.value;
        version =  selectedOption.label;
    }

    renderSelect() {
        if (document.getElementById('versionSelector') == undefined) {
            let node = document.createElement("div");
            node.id = 'versionSelector';
            insertAfter(node, getImagesByAlt("logo")[0].parentElement);
            ReactDOM.render(
                <Select
                    placeholder={version}
                    value={value}
                    onChange={this.selectChange}
                    options={options}
                    styles={customStyles}
                />,
                document.getElementById("versionSelector")
            );
        }
    }

    renderDescription() {
        if (document.getElementById("tmsDescription") == undefined && version == 'Version 3.1') {
            let node = document.createElement("div");
            node.id = "tmsDescription";
            insertAfter(node, getAnchorsContainingSubhref("#tag/TMS-Checks")[0].parentElement);
            ReactDOM.render(description, document.getElementById("tmsDescription")
            );
        }
    }

    renderElements() {
        this.renderSelect()
        this.renderDescription()
    }

    render() {
        return (
            <>
                <ToastContainer/>
                <RedocStandalone
                    specUrl={this.state.specUrl}
                    onLoaded={() => this.renderElements()}
                    options={{
                        theme: {
                            colors: {
                                primary: {
                                    main: colors.blackish,
                                }
                            },
                            typography: {
                                fontFamily: 'Open Sans, sans-serif',
                                headings: {
                                    fontFamily: 'Open Sans, sans-serif'
                                },
                            },
                            logo: {
                                gutter: '20px',
                            }
                        },
                        sortPropsAlphabetically: true,
                        requiredPropsFirst: true
                    }}
                />
            </>
            );
    }
}

ReactDOM.render(
    <Page/>,
    document.getElementById('root'),
    showToast(shouldShowNotification(lastSeenNotificationIds)),
);

function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function getImagesByAlt(alt) {
    let allImages = document.getElementsByTagName("img");
    let images = [];
    for (let i = 0, len = allImages.length; i < len; ++i) {
        if (allImages[i].alt == alt) {
            images.push(allImages[i]);
        }
    }
    return images;
}

function getAnchorsContainingSubhref(href) {
    let allAnchors = document.getElementsByTagName("a");
    let anchors = [];
    for (let i = 0, len = allAnchors.length; i < len; ++i) {
        if (allAnchors[i].href.includes(href)) {
            anchors.push(allAnchors[i]);
        }
    }
    return anchors;
}
